import { PEER_CONFIGURATION_API } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { fetchpeerConfigurationFailure, fetchpeerConfigurationSuccess } from "./reducer";

export const getAllPeerConfiguration = (setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${PEER_CONFIGURATION_API}`,'GET')
        setLoading(false)
        if (response.error && response.error.code === 'NotFound') {
            dispatch(fetchpeerConfigurationSuccess([]));
        }
        else {
            dispatch(fetchpeerConfigurationSuccess(response.reverse()))
        }
    }
    catch (error) {
        setLoading(false)
        dispatch(fetchpeerConfigurationFailure(error.message))
    }
}